import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { get } from 'node-emoji';
import {
  EmojiPicker,
  EmojiPickerList,
  EmojiPickerTrigger,
} from '../components/EmojiPicker';
import Loader from '../components/Loader';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useSpaceContext } from '../contexts/space';
import { SPACE } from '../utilities/queries';
import { UPDATE_SPACE_ICON } from '../utilities/mutations';

const EditSpaceIconModal = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { spaceVars } = useSpaceContext();
  const { loading, data } = useQuery(SPACE, {
    variables: { slug: params.s, ...spaceVars },
  });
  const [updateSpaceIcon] = useMutation(UPDATE_SPACE_ICON);

  const close = () => navigate(`/s/${params.s}/settings/main`);

  const [emoji, setEmoji] = useState(data && data.space.icon);
  const [isLoading, setIsLoading] = useState(false);

  const customSetEmoji = (value) => {
    if (data) {
      setEmoji(value);
      setIsLoading(true);
      updateSpaceIcon({
        variables: {
          id: data.space.id,
          icon: value,
        },
      });
      setIsLoading(false);
    }
  };

  return (
    <Modal onClose={() => close()}>
      {loading ? (
        <ModalPart>
          <Loader />
        </ModalPart>
      ) : (
        <>
          <ModalExit />
          <ModalName>Edit space icon</ModalName>
          <ModalPart>
            <EmojiPicker
              emoji={data.space.icon ? get(emoji) : '-'}
              setEmoji={customSetEmoji}
            >
              <EmojiPickerTrigger disabled={isLoading} data-autofocus />
              <EmojiPickerList />
            </EmojiPicker>
          </ModalPart>
        </>
      )}
    </Modal>
  );
};

export default EditSpaceIconModal;
